import { Icon, Popover } from '@neshane/blueberry';

import { useAuth } from '../../../modules/Authentication';
import { NavLink } from '../NavLink';
import HelpTooltip from './HelpTooltip';

const QUESTIONS = [
  {
    title: 'نحوه ثبت‌نام و احراز هویت',
    link: '/profile',
  },
  {
    title: 'صدور گواهی دیجیتال',
    link: '/certificates',
  },
  {
    title: 'امضای PDF',
    link: '/sign-pdf',
  },
];

const ticketsHrefForRole = (role) => {
  if (role === 'admin') return '/admin/tickets';
  if (role === 'operator') return '/operator/tickets';
  return '/tickets';
};

export const HelpButton = ({ href }) => {
  const { user } = useAuth();
  const ticketsHref = ticketsHrefForRole(user?.role);

  if (href) {
    return (
      <li>
        <NavLink href={href} iconName="circle-question-outline" activePaths={[href]}>
          راهنمایی
        </NavLink>
      </li>
    );
  }

  return (
    <li>
      <Popover
        placement="top-end"
        className="popover-hack-align w-full"
        renderTrigger={({ isDropdown: _, ...rest }) => {
          return (
            <button {...rest} className="navigation-item h-40" type="button">
              <Icon
                name="circle-question-outline"
                aria-hidden="true"
                className="shrink-0"
              />
              <span className="navigation-toggle-display grow">
                راهنمایی
              </span>
            </button>
          );
        }}
      >
        {(closeDropdown) => (
          <HelpTooltip questions={QUESTIONS} onClose={closeDropdown} ticketsHref={ticketsHref} />
        )}
      </Popover>
    </li>
  );
};

export default HelpButton;